<template>
  <section class="app-main content">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AppMain',
  computed: {
    ...mapState({
      donationStatsState: (state) => state.donations.donationStatsState,
      routeRefreshToken: (state) => state.app.routeRefreshToken,
    }),
    key() {
      return `${this.$route.path}-${this.routeRefreshToken}`
    },
  },
}
</script>

<style scoped lang="scss">
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
.app-main {
  min-height: calc(100vh);
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #ecf1f8;
}
.fixed-header + .app-main {
  padding-top: 69px;
}
</style>
